/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SharedStreakInviteBody
 */
export interface SharedStreakInviteBody {
    /**
     * 
     * @type {string}
     * @memberof SharedStreakInviteBody
     */
    streakConfigId: string;
    /**
     * 
     * @type {string}
     * @memberof SharedStreakInviteBody
     */
    toUserId: string;
}

/**
 * Check if a given object implements the SharedStreakInviteBody interface.
 */
export function instanceOfSharedStreakInviteBody(value: object): value is SharedStreakInviteBody {
    if (!('streakConfigId' in value) || value['streakConfigId'] === undefined) return false;
    if (!('toUserId' in value) || value['toUserId'] === undefined) return false;
    return true;
}

export function SharedStreakInviteBodyFromJSON(json: any): SharedStreakInviteBody {
    return SharedStreakInviteBodyFromJSONTyped(json, false);
}

export function SharedStreakInviteBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): SharedStreakInviteBody {
    if (json == null) {
        return json;
    }
    return {
        
        'streakConfigId': json['streakConfigId'],
        'toUserId': json['toUserId'],
    };
}

export function SharedStreakInviteBodyToJSON(json: any): SharedStreakInviteBody {
    return SharedStreakInviteBodyToJSONTyped(json, false);
}

export function SharedStreakInviteBodyToJSONTyped(value?: SharedStreakInviteBody | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'streakConfigId': value['streakConfigId'],
        'toUserId': value['toUserId'],
    };
}

